import { useEffect } from 'react';
import { Collapse, Box, Container } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import styles from './custom-table-mobile.module.css';

export type TTableMobileRowItem = {
  name?: string | number;
  value: React.ReactNode;
};

export type TTableMobileRow = {
  key: string | number | null;
  headerActions?: React.ReactNode;
  items: TTableMobileRowItem[];
};

const getItemKey = (item: TTableMobileRowItem, index: number) => `${item.name}-${item.value}-${index}`;

type Props = {
  row: TTableMobileRow;
  headerPointsCount?: number;
  headerActions?: React.ReactNode;
  isOpen?: boolean;
};

export const CustomTableMobileItem = (props: Props) => {
  const {
    row,
    headerPointsCount,
    isOpen = false,
  } = props;

  const [opened, { toggle, open: itemOpen, close: itemClose }] = useDisclosure(isOpen);

  useEffect(() => {
    if (isOpen) {
      itemOpen();
    } else {
      itemClose();
    }
  }, [isOpen]);

  return (
    <Box key={row.key} className={styles['table-item']}>
      <header
        className={styles['table-item-header']}
        onClick={toggle}
      >
        <div className={styles['table-header-left']}>
          {row.items.slice(0, headerPointsCount).map((item, index) => (
            <p className={styles['table-item-point']} key={getItemKey(item, index)}>
              {item.name && (
                <span className={styles['table-item-name']}>{item.name}</span>
              )}
              <span className={`${styles['table-item-value']} ${!item.name && styles['table-item-full-width']}`}>{item.value}</span>
            </p>
          ))}
        </div>
        <div className={styles['table-header-actions']} onClick={(e) => e.stopPropagation()}>
          {row.headerActions && (
            row.headerActions
          )}
        </div>
      </header>

      <Collapse in={opened}>
        <Container mt={10} mb={10} size="lg">
          {row.items.slice(headerPointsCount).map((item, index) => (
            <div className={styles['table-item-point']} key={getItemKey(item, index)}>
              {item.name && (
                <span className={styles['table-item-name']}>{item.name}</span>
              )}
              <span className={`${styles['table-item-value']} ${!item.name && styles['table-item-full-width']}`}>{item.value}</span>
            </div>
          ))}
        </Container>
      </Collapse>
    </Box>
  );
};
